import React from 'react'

/**
 * 사용자 정보
 */
const UserContext = React.createContext({
  EMP_NAME: '',
  EMP_NUMBER: '1106011233',
  HRDEPT_NAMK: '인사팀',
  LEADER_NAME: '이영주',
})

export default UserContext
